import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  linkText: {
    color: theme.colors.darkPurpleBlue,
    textDecorationLine: 'underline',
    fontWeight: '600',
  },
  licenseBanner: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 10,
    backgroundColor: theme.colors.newUI.therapist.orange30,
  },
  additionalContactBanner: {
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: theme.colors.newUI.therapist.grey30,
  },
});
